import './style.css';
import React from 'react';
import { Button, Dialog } from '@economic/taco';
import { t, useLocalization } from '../../l10n/l10n';
import ExternalLink from '../../ExternalLink';

interface Props {
    onOk: () => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}

export default function VismaConnectMissing2FaDialog({ onOk, open, setOpen }: Props) {
    const loadingTexts = useLocalization(textIds);

    if (loadingTexts || !open) {
        return null;
    }

    return (
        <Dialog open={open} onChange={setOpen} showCloseButton={false} closeOnEscape={false}>
            <Dialog.Content aria-label={t`MISSING_2FA_MODAL_TITLE`}>
                <Dialog.Title>{t`MISSING_2FA_MODAL_TITLE`}</Dialog.Title>
                <div className="vismaconnect-missing-2fa m-auto">
                    <div style={{ paddingBottom: '20px' }}>{t`MISSING_2FA_MODAL_CONTENT`}</div>
                    <div style={{ paddingBottom: '40px' }}>
                        <ExternalLink href={t`MISSING_2FA_MODAL_LINK_URL`}>{t`MISSING_2FA_MODAL_LINK_TEXT`}</ExternalLink>
                    </div>
                    <div>
                        <Dialog.Close>
                            <Button
                                appearance="primary"
                                style={{ width: '70%' }}
                                type="button"
                                onClick={() => {
                                    onOk();
                                }}>
                                {t`MISSING_2FA_MODAL_CONFIRM`}
                            </Button>
                        </Dialog.Close>
                    </div>
                </div>
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = [
    'MISSING_2FA_MODAL_TITLE',
    'MISSING_2FA_MODAL_CONTENT',
    'MISSING_2FA_MODAL_LINK_TEXT',
    'MISSING_2FA_MODAL_LINK_URL',
    'MISSING_2FA_MODAL_CONFIRM',
];
